export default __webpack_public_path__ + "static/media/blog2.ae7abd31.jpg";